import '../../components.theme/shops-filters-panel/shops-filters-panel';
import './shops-filters-panel.scss';
